import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12 * (props.wx ?? 1)}
    height={30 * (props.hx ?? 1)}
    viewBox="0 0 12 30"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.893 20.851c-.173-.683-.398-1.099-.684-1.554-.258-.413-.499-.75-.538-1.236-.234-2.906-1.096-7.987-1.238-12.11C7.295 1.96 6.276 1.175 5.77 1.213 5.21 1.255 5.159 3 4.574 5.66c-.627 2.857-.897 4.43-1.256 6.448-.4 2.246-.414 3.451-.67 4.927-.144.825-.246 1.367-.377 1.782a4.9 4.9 0 0 1-.57 1.269c-.612 1.024-1.118 5.498-.194 6.84.561.815.912 1.163 1.722 1.39.51.144 1.632.783 2.488.798.806.015 1.464-.239 2.615-.572.785-.227 1.228-.38 1.78-1.089.91-1.167.278-4.646-.219-6.6z"
    />
  </svg>
);
export default SvgNormal;
